export const myTruncatePlugin = (store) => {
  store.truncate = function(str) {
    return str.replace(/-/g, "") + " ...was truncaaaated!"; // example implementation
  };
};

export const consoleState = (store) => {
  store.debug = function() {
    console.log(store, store.state);
  };
};

export const allPlugins = [myTruncatePlugin, consoleState];
